
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hwjejrsktuenskryvsvl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh3amVqcnNrdHVlbnNrcnl2c3ZsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzgzOTYyMzIsImV4cCI6MjA1Mzk3MjIzMn0.plIHcFvLnyWgrQZIDvGwVGRL2fN3pq9dlsSKjyDNRIs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
